export default __webpack_public_path__ + "static/media/ic_one_coin.e6d017b8.png";